const FEEDBACK_REPLIES_DOMAIN = 'feedbackReplies'

const FEEDBACK_REPLIES_KEY = {
  ALL: 'all',
  DATA: 'data',
  CURRENT: 'current'
}

const FEEDBACK_REPLIES_PATH = {
  ALL: `${FEEDBACK_REPLIES_DOMAIN}.${FEEDBACK_REPLIES_KEY.ALL}`,
  DATA: `${FEEDBACK_REPLIES_DOMAIN}.${FEEDBACK_REPLIES_KEY.DATA}`,
  CURRENT: `${FEEDBACK_REPLIES_DOMAIN}.${FEEDBACK_REPLIES_KEY.CURRENT}`
}

const FEEDBACK_REPLIES_STATE = {
  [FEEDBACK_REPLIES_KEY.ALL]: {
    data: [],
    status: null
  },
  [FEEDBACK_REPLIES_KEY.DATA]: {},
  [FEEDBACK_REPLIES_KEY.CURRENT]: null
}

const FEEDBACK_REPLIES_ANALYTICS_EVENT = {
  READ: 'Feedback Replies Read'
}

const FEEDBACK_REPLIES_ACTION = {
  CREATE: 'FEEDBACK_REPLIES_CREATE',
  SAVE: 'FEEDBACK_REPLIES_SAVE',
  UPDATE_MESSAGE: 'FEEDBACK_REPLIES_UPDATE_MESSAGE',
  UPDATE_READ_AT: 'FEEDBACK_REPLIES_UPDATE_READ_AT',
  UPDATE_CURRENT: 'FEEDBACK_REPLIES_UPDATE_CURRENT',
  DELETE_CURRENT: 'FEEDBACK_REPLIES_DELETE_CURRENT',
  UPDATE_READ: 'FEEDBACK_REPLIES_UPDATE_READ'
}

const FEEDBACK_REPLIES_ENDPOINT = {
  FEEDBACK_REPLIES: '/feedback-replies'
}

export {
  FEEDBACK_REPLIES_DOMAIN,
  FEEDBACK_REPLIES_KEY,
  FEEDBACK_REPLIES_PATH,
  FEEDBACK_REPLIES_STATE,
  FEEDBACK_REPLIES_ANALYTICS_EVENT,
  FEEDBACK_REPLIES_ENDPOINT,
  FEEDBACK_REPLIES_ACTION
}
